<div
	style="
		width: 100%;
		display: flex;
		flex-flow: column;
		align-items: center;
		min-height: 200px;
		border-top: 1px solid #ddd;
		border-bottom: 1px solid #ddd;
		padding-top: 20px;
		background: #fff;
	"
>
	<div
		*ngFor="let msg of selectedConversation?.messages"
		style="width: 100%; display: flex; flex-flow: column; align-items: center"
	>
		<div [ngClass]="{ 'message-right': msg.webUser, 'message-left': msg.ahsUser }" style="">
			<div>
				<span style="">{{ msg.webUser }} {{ msg.ahsUser | translate }}</span>
				<span style="color: #666"> - {{ msg.createdDate | date: 'M/d/yyyy, h:mm a' }}</span>
			</div>
			<mat-card
				appearance="outlined"
				class="keep-whitespace"
				[ngClass]="{ 'message-detail-right': msg.webUser, 'message-detail-left': msg.ahsUser }"
				>{{ msg.text }}</mat-card
			>
			<div></div>
		</div>
	</div>

	<div
		class=""
		[formGroup]="newMessageForm"
		novalidate
		#myNewMessageForm
		style="width: 100%; padding: 20px"
		*ngIf="selectedConversation?.conversationStatus?.codeName.toUpperCase() == 'OPEN'"
	>
		<mat-form-field
			class=""
			tabindex="-1"
			appearance="outline"
			style="width: 100%; display: flex; flex-flow: row; align-items: flex-start"
		>
			<textarea
				#msgTextarea
				maxlength="1000"
				matInput
				formControlName="message"
				style="margin-right: 10px"
				placeholder="{{ 'TYPE_MESSAGE_HERE' | translate }}"
			></textarea>
			<mat-hint align="end">{{ msgTextarea.value?.length || 0 }} / 1000</mat-hint>
			<mat-error *ngIf="newMessageForm.controls['message']?.invalid" class="large-text">{{
				'MESSAGE_ERROR' | translate
			}}</mat-error>
			<button
				*ngIf="!loadingData.sendingMessage"
				mat-mini-fab
				style="align-self: flex-end; background-color: #2b78e4; box-shadow: none"
				(click)="sendMessage()"
			>
				<mat-icon style="margin-left: 3px; margin-top: -2px" aria-label="Send Message">send</mat-icon>
			</button>
			<mat-spinner *ngIf="loadingData.sendingMessage" [diameter]="36"></mat-spinner>
		</mat-form-field>
	</div>
	<div
		style="display: flex; flex-flow: column; align-items: center; width: 100%"
		*ngIf="selectedConversation?.conversationStatus?.codeName?.toUpperCase() == 'CLOSED'"
	>
		<mat-card
			appearance="outlined"
			style="display: flex; flex-flow: row; align-items: center; justify-content: center; width: 70%"
			class="closed-message message-detail-left"
		>
			{{ 'MARKED_CLOSED_BY' | translate }} {{ selectedConversation?.displayUserCompletedBy }}
			{{ 'AT' | translate }} {{ selectedConversation?.modifiedDate | date: 'M/d/yyyy' }}
		</mat-card>
		<div
			style="
				width: 100%;
				height: 60px;
				display: flex;
				flex-flow: row;
				align-items: center;
				justify-content: center;
			"
			class="light-grey-background make-it-blue"
		>
			<div style="">{{ 'CANNOT_REPLY' | translate }}</div>
		</div>
	</div>
	<div id="bottomAnchor"></div>
</div>
